import React, { PropsWithChildren } from 'react';
import useWindowDimensions from './useWindowDimensions';

export interface IRenderingInfo {
    isMobileVersion: boolean;
    isBigDesktop: boolean;
}

const RenderingInfoContext = React.createContext<IRenderingInfo | undefined>(undefined);

/**
 * Provides information about the rendering environment, primarily if the screen is mobile.
 */
export const RenderingInfoProvider: React.FC<PropsWithChildren<any>> = ({ children }) => {
    const MAX_MOBILE_WIDTH = 768;
    const MIN_BIG_DEKSTOP_WIDTH = 1024;
    const { width } = useWindowDimensions();

    const renderingInfo: IRenderingInfo = {
        isMobileVersion: width <= MAX_MOBILE_WIDTH,
        isBigDesktop: width > MIN_BIG_DEKSTOP_WIDTH,
    };
    return <RenderingInfoContext.Provider value={renderingInfo}>{children}</RenderingInfoContext.Provider>;
};

export const useRenderingInfo = () => {
    const renderingInfo = React.useContext(RenderingInfoContext);
    if (!renderingInfo) {
        throw new Error('useRenderingInfo must be used within a RenderingInfoProvider');
    }
    return renderingInfo;
};
